/**
 * Shared shift-filter helper.
 *
 * Background: the /shifts endpoint returns ALL shifts including ones
 * where is_active=false (deprecated shifts a plant no longer runs).
 * Every daily-use dropdown (Daily Shift Log, Worker Allocation,
 * Attendance, Production Log, QC) wants active shifts only — the
 * master page is the only place that needs to see deactivated ones,
 * and it queries directly.
 *
 * Use this in any useQuery that fetches /shifts for a picker.
 */

/** Keep only shifts that aren't explicitly deactivated. Missing flag = active. */
export function filterActiveShifts<T>(shifts: readonly T[]): T[] {
  return shifts.filter((s) => (s as { is_active?: boolean }).is_active !== false)
}
